import { useState } from "react";

const SIDEBAR_LINKS = [
  { section: "ACCUEIL", links: [
    { icon: "◆", label: "Tableau de bord" },
    { icon: "📢", label: "Annonces & actualités" },
  ]},
  { section: "SCOLARITÉ", links: [
    { icon: "👨‍🎓", label: "Élèves" },
    { icon: "✓", label: "Présences élèves" },
    { icon: "📊", label: "Rapport d'absences" },
  ]},
  { section: "PÉDAGOGIE", links: [
    { icon: "◎", label: "Évaluations" },
    { icon: "◆", label: "Bulletins" },
    { icon: "🏆", label: "Classements" },
  ]},
  { section: "FINANCE", links: [
    { icon: "💰", label: "Gestion paiements" },
    { icon: "💳", label: "Trésorerie" },
  ]},
];

const KPIS = [
  { label: "Élèves inscrits", value: "248", sub: "+12 ce mois", border: "#bfdbfe", bg: "#eff6ff", val: "#1d4ed8", icon: "👨‍🎓" },
  { label: "Personnel", value: "34", sub: "28 enseignants", border: "#ddd6fe", bg: "#f5f3ff", val: "#7c3aed", icon: "👨‍🏫" },
  { label: "Taux de réussite", value: "87%", sub: "+5% vs T1", border: "#bbf7d0", bg: "#f0fdf4", val: "#16a34a", icon: "📈" },
  { label: "Impayés", value: "3.2M F", sub: "12 élèves", border: "#fde68a", bg: "#fffbeb", val: "#b45309", icon: "⚠" },
];

const STUDENTS = [
  { matricule: "GSLP-0001", name: "Compaoré Aïcha", classe: "6e A", cycle: "Post-Élémentaire", moyenne: 14.5 },
  { matricule: "GSLP-0002", name: "Zongo Boureima", classe: "6e A", cycle: "Post-Élémentaire", moyenne: 11.2 },
  { matricule: "GSLP-0003", name: "Diallo Salimata", classe: "CM2 A", cycle: "Élémentaire", moyenne: 16.8 },
  { matricule: "GSLP-0004", name: "Ouattara Karim", classe: "PS A", cycle: "Pré-Scolaire", moyenne: null },
  { matricule: "GSLP-0005", name: "Sawadogo Fatima", classe: "2nde A", cycle: "Secondaire", moyenne: 13.1 },
];

const CYCLE_COLORS = {
  "Post-Élémentaire": { bg: "#ede9fe", color: "#7c3aed" },
  "Élémentaire":      { bg: "#dbeafe", color: "#1d4ed8" },
  "Pré-Scolaire":     { bg: "#fef3c7", color: "#b45309" },
  "Secondaire":       { bg: "#dcfce7", color: "#16a34a" },
};

export default function ThemePreview() {
  const [active, setActive] = useState("Tableau de bord");
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <div style={{ display: "flex", height: "100vh", background: "#f1f5f9", fontFamily: "system-ui,-apple-system,sans-serif", fontSize: 13, overflow: "hidden" }}>

      {/* Sidebar */}
      <aside style={{ width: sidebarOpen ? 220 : 52, background: "#0f2744", display: "flex", flexDirection: "column", flexShrink: 0, transition: "width .2s ease" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "14px 12px", borderBottom: "1px solid rgba(255,255,255,.08)" }}>
          <div style={{ width: 32, height: 32, borderRadius: 8, background: "#3b82f6", color: "#fff", display: "grid", placeItems: "center", fontWeight: 700, fontSize: 14, flexShrink: 0 }}>S</div>
          {sidebarOpen && <div><div style={{ color: "#fff", fontWeight: 600, fontSize: 14 }}>Schoolizy</div><div style={{ color: "rgba(255,255,255,.35)", fontSize: 10 }}>La Providence</div></div>}
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 12px", borderBottom: "1px solid rgba(255,255,255,.08)" }}>
          <div style={{ width: 28, height: 28, borderRadius: "50%", background: "#2563eb", color: "#fff", display: "grid", placeItems: "center", fontSize: 10, fontWeight: 700, flexShrink: 0 }}>AS</div>
          {sidebarOpen && <div><div style={{ color: "#fff", fontSize: 11, fontWeight: 500 }}>Awa Sanou</div><div style={{ color: "rgba(255,255,255,.35)", fontSize: 10 }}>ADMIN_ECOLE</div></div>}
        </div>

        <nav style={{ flex: 1, overflowY: "auto", padding: "8px 0" }}>
          {SIDEBAR_LINKS.map((group) => (
            <div key={group.section}>
              {sidebarOpen && <div style={{ padding: "10px 14px 4px", fontSize: 9, fontWeight: 700, letterSpacing: "0.1em", color: "rgba(255,255,255,.25)", textTransform: "uppercase" }}>{group.section}</div>}
              {group.links.map((link) => {
                const isActive = active === link.label;
                return (
                  <button key={link.label} onClick={() => setActive(link.label)}
                    style={{ width: "calc(100% - 12px)", margin: "1px 6px", display: "flex", alignItems: "center", gap: 9, padding: "7px 10px", borderRadius: 8, border: "none", cursor: "pointer", fontSize: 12, background: isActive ? "rgba(59,130,246,.2)" : "transparent", color: isActive ? "#93c5fd" : "rgba(255,255,255,.5)", fontWeight: isActive ? 600 : 400 }}>
                    <span style={{ fontSize: 13, width: 16, textAlign: "center", flexShrink: 0 }}>{link.icon}</span>
                    {sidebarOpen && <span>{link.label}</span>}
                  </button>
                );
              })}
            </div>
          ))}
        </nav>

        <div style={{ padding: 10, borderTop: "1px solid rgba(255,255,255,.08)" }}>
          <button onClick={() => setSidebarOpen(!sidebarOpen)}
            style={{ width: "100%", padding: 6, border: "1px solid rgba(255,255,255,.1)", borderRadius: 6, background: "transparent", color: "rgba(255,255,255,.35)", fontSize: 10, cursor: "pointer" }}>
            {sidebarOpen ? "← Réduire" : "→"}
          </button>
        </div>
      </aside>

      {/* Main */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0 }}>

        {/* Topbar */}
        <header style={{ background: "#fff", borderBottom: "1px solid #e2e8f0", padding: "12px 24px", display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 }}>
          <div>
            <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: "0.1em", color: "#94a3b8", textTransform: "uppercase" }}>Pilotage</div>
            <h1 style={{ fontSize: 18, fontWeight: 700, color: "#0f172a", margin: 0 }}>Tableau de bord</h1>
          </div>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 6, padding: "6px 12px", border: "1px solid #e2e8f0", borderRadius: 999, fontSize: 11, color: "#64748b", background: "#f8fafc" }}>
              🏫 <span style={{ fontWeight: 500, color: "#334155" }}>La Providence</span>
            </div>
            <div style={{ position: "relative" }}>
              <button style={{ width: 32, height: 32, borderRadius: 8, border: "1px solid #e2e8f0", background: "#fff", display: "grid", placeItems: "center", cursor: "pointer" }}>🔔</button>
              <span style={{ position: "absolute", top: -2, right: -2, width: 14, height: 14, borderRadius: "50%", background: "#ef4444", color: "#fff", fontSize: 8, display: "grid", placeItems: "center", fontWeight: 700 }}>3</span>
            </div>
          </div>
        </header>

        {/* Content */}
        <main style={{ flex: 1, overflowY: "auto", padding: 20 }}>

          {/* KPIs */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12, marginBottom: 20 }}>
            {KPIS.map((kpi) => (
              <div key={kpi.label} style={{ background: kpi.bg, borderRadius: 14, border: `1px solid ${kpi.border}`, padding: "14px 16px", boxShadow: "0 1px 4px rgba(0,0,0,.06)" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
                  <span style={{ fontSize: 11, color: "#64748b", fontWeight: 500 }}>{kpi.label}</span>
                  <span style={{ fontSize: 18 }}>{kpi.icon}</span>
                </div>
                <div style={{ fontSize: 24, fontWeight: 800, fontFamily: "monospace", color: kpi.val }}>{kpi.value}</div>
                <div style={{ fontSize: 10, color: "#94a3b8", marginTop: 4 }}>{kpi.sub}</div>
              </div>
            ))}
          </div>

          {/* 2 colonnes */}
          <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr", gap: 14, marginBottom: 14 }}>

            {/* Cours du jour */}
            <div style={{ background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", overflow: "hidden", boxShadow: "0 1px 3px rgba(0,0,0,.06)" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 16px", borderBottom: "1px solid #f1f5f9" }}>
                <h2 style={{ margin: 0, fontSize: 13, fontWeight: 600, color: "#1e293b" }}>● Cours du jour — Vendredi</h2>
                <button style={{ fontSize: 11, color: "#3b82f6", background: "none", border: "none", cursor: "pointer" }}>Voir l'EDT →</button>
              </div>
              {[
                { time: "08:00–09:00", subject: "Français", classe: "6e A", teacher: "Kaboré F.", room: "Salle A1" },
                { time: "09:00–10:00", subject: "Mathématiques", classe: "6e A", teacher: "Traoré I.", room: "Salle A1" },
                { time: "11:00–12:00", subject: "Calcul", classe: "CM2 A", teacher: "Ouédraogo S.", room: "Salle B2" },
              ].map((c, i) => (
                <div key={i} style={{ display: "flex", alignItems: "center", padding: "9px 16px", borderBottom: "1px solid #f8fafc" }}>
                  <span style={{ fontFamily: "monospace", fontSize: 11, color: "#94a3b8", width: 90 }}>{c.time}</span>
                  <span style={{ fontWeight: 600, color: "#1e293b", flex: 1, fontSize: 12 }}>{c.subject}</span>
                  <span style={{ fontSize: 11, color: "#64748b", width: 56 }}>{c.classe}</span>
                  <span style={{ fontSize: 11, color: "#64748b", width: 90 }}>{c.teacher}</span>
                  <span style={{ fontSize: 10, background: "#f1f5f9", color: "#64748b", padding: "2px 8px", borderRadius: 999 }}>{c.room}</span>
                </div>
              ))}
            </div>

            {/* Trésorerie */}
            <div style={{ background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", overflow: "hidden", boxShadow: "0 1px 3px rgba(0,0,0,.06)" }}>
              <div style={{ padding: "12px 16px", borderBottom: "1px solid #f1f5f9" }}>
                <h2 style={{ margin: 0, fontSize: 13, fontWeight: 600, color: "#1e293b" }}>Trésorerie du mois</h2>
              </div>
              <div style={{ padding: 16 }}>
                <div style={{ marginBottom: 12 }}>
                  <div style={{ fontSize: 10, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 4 }}>Solde total</div>
                  <div style={{ fontSize: 22, fontWeight: 800, fontFamily: "monospace", color: "#1d4ed8" }}>11 492 500 F</div>
                </div>
                <div style={{ height: 1, background: "#f1f5f9", marginBottom: 12 }} />
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>
                  <div><div style={{ fontSize: 10, color: "#94a3b8" }}>Recettes</div><div style={{ fontWeight: 700, fontFamily: "monospace", color: "#16a34a" }}>1 360 000 F</div></div>
                  <div style={{ textAlign: "right" }}><div style={{ fontSize: 10, color: "#94a3b8" }}>Dépenses</div><div style={{ fontWeight: 700, fontFamily: "monospace", color: "#ef4444" }}>600 000 F</div></div>
                </div>
                <div style={{ height: 8, background: "#f1f5f9", borderRadius: 999, overflow: "hidden", marginBottom: 10 }}>
                  <div style={{ height: "100%", width: "69%", background: "#16a34a", borderRadius: 999 }} />
                </div>
                <button style={{ width: "100%", fontSize: 11, color: "#3b82f6", background: "none", border: "none", cursor: "pointer" }}>Voir la trésorerie →</button>
              </div>
            </div>
          </div>

          {/* Table élèves */}
          <div style={{ background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", overflow: "hidden", boxShadow: "0 1px 3px rgba(0,0,0,.06)" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 16px", borderBottom: "1px solid #f1f5f9" }}>
              <h2 style={{ margin: 0, fontSize: 13, fontWeight: 600, color: "#1e293b" }}>Registre des élèves</h2>
              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <div style={{ position: "relative" }}>
                  <span style={{ position: "absolute", left: 8, top: "50%", transform: "translateY(-50%)", fontSize: 12, color: "#94a3b8" }}>🔍</span>
                  <input style={{ paddingLeft: 26, height: 28, fontSize: 11, border: "1px solid #e2e8f0", borderRadius: 8, background: "#f8fafc", width: 140, outline: "none" }} placeholder="Nom, matricule…" />
                </div>
                <select style={{ height: 28, fontSize: 11, border: "1px solid #e2e8f0", borderRadius: 8, background: "#f8fafc", padding: "0 8px", outline: "none" }}>
                  <option>Tous les cycles</option>
                </select>
                <button style={{ height: 28, padding: "0 12px", background: "#3b82f6", color: "#fff", fontSize: 11, fontWeight: 600, borderRadius: 8, border: "none", cursor: "pointer" }}>+ Nouvel élève</button>
              </div>
            </div>

            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ background: "#f8fafc" }}>
                  {["Matricule", "Nom & Prénom", "Classe", "Cycle", "Moyenne", "Statut", ""].map((h) => (
                    <th key={h} style={{ textAlign: "left", fontSize: 10, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.06em", padding: "9px 14px", borderBottom: "1px solid #f1f5f9" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {STUDENTS.map((s) => {
                  const badge = CYCLE_COLORS[s.cycle];
                  const moyColor = s.moyenne ? (s.moyenne >= 10 ? "#16a34a" : "#ef4444") : "#b45309";
                  return (
                    <tr key={s.matricule} style={{ borderBottom: "1px solid #f8fafc" }}>
                      <td style={{ padding: "10px 14px", fontFamily: "monospace", fontSize: 11, color: "#64748b" }}>{s.matricule}</td>
                      <td style={{ padding: "10px 14px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <div style={{ width: 26, height: 26, borderRadius: "50%", background: "#2563eb", color: "#fff", display: "grid", placeItems: "center", fontSize: 9, fontWeight: 700, flexShrink: 0 }}>
                            {s.name.split(" ").map(n => n[0]).join("").slice(0, 2)}
                          </div>
                          <span style={{ fontWeight: 600, color: "#1e293b", fontSize: 12 }}>{s.name}</span>
                        </div>
                      </td>
                      <td style={{ padding: "10px 14px", fontSize: 11, color: "#475569" }}>{s.classe}</td>
                      <td style={{ padding: "10px 14px" }}>
                        <span style={{ fontSize: 10, fontWeight: 600, padding: "3px 8px", borderRadius: 999, background: badge.bg, color: badge.color }}>{s.cycle}</span>
                      </td>
                      <td style={{ padding: "10px 14px" }}>
                        {s.moyenne
                          ? <span style={{ fontFamily: "monospace", fontWeight: 700, fontSize: 12, color: moyColor }}>{s.moyenne}/20</span>
                          : <span style={{ fontSize: 10, background: "#fef3c7", color: "#b45309", padding: "2px 8px", borderRadius: 999 }}>AEA</span>
                        }
                      </td>
                      <td style={{ padding: "10px 14px" }}>
                        <span style={{ fontSize: 10, fontWeight: 600, padding: "3px 8px", borderRadius: 999, background: "#dcfce7", color: "#16a34a" }}>Inscrit</span>
                      </td>
                      <td style={{ padding: "10px 14px", textAlign: "right" }}>
                        <div style={{ display: "flex", gap: 4, justifyContent: "flex-end" }}>
                          {["Fiche", "Modifier"].map((l) => (
                            <button key={l} style={{ fontSize: 10, padding: "4px 8px", border: "1px solid #e2e8f0", borderRadius: 6, background: "#fff", color: "#475569", cursor: "pointer" }}>{l}</button>
                          ))}
                          <button style={{ fontSize: 10, padding: "4px 8px", border: "1px solid #fee2e2", borderRadius: 6, background: "#fff", color: "#ef4444", cursor: "pointer" }}>Radier</button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 14px", background: "#f8fafc", borderTop: "1px solid #f1f5f9" }}>
              <span style={{ fontSize: 11, color: "#94a3b8" }}>1–5 sur 248 résultats</span>
              <div style={{ display: "flex", gap: 4 }}>
                {["«", "‹", "1", "2", "3", "›", "»"].map((p, i) => (
                  <button key={i} style={{ width: 28, height: 28, borderRadius: 7, border: "1px solid", borderColor: p === "1" ? "#3b82f6" : "#e2e8f0", background: p === "1" ? "#3b82f6" : "#fff", color: p === "1" ? "#fff" : "#64748b", fontSize: 11, cursor: "pointer" }}>{p}</button>
                ))}
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
